<template>
  <div class="post-body">
    <vue-mathjax
      :formula="body"
      :safe="false"
    ></vue-mathjax>
  </div>
</template>
<script>
import { VueMathjax } from 'vue-mathjax'
import hljs from 'highlight.js'
window.hljs = hljs

export default{
  name: 'PostBody',
  components: {
    'vue-mathjax': VueMathjax,
  },

  props: {
    body: {
      type: String,
      default: '',
    },
    //bodyFormat: {
    //  type: String,
    //  default: 'html',
    //}
  },

  data(){
    return {
    }
  },

  computed: {
  },

  mounted() {
    window.hljs.highlightAll()
  },

  methods: {
  },
}
</script>
<style>
@import "~highlight.js/styles/atom-one-dark.css";

.post-body {
  @import "@/scss/browser-default.scss";
  pre {
    padding: 0 0;
  }
}
</style>

